import { render, staticRenderFns } from "./CollectionOeReminder.vue?vue&type=template&id=e7035fbc&"
import script from "./CollectionOeReminder.vue?vue&type=script&lang=js&"
export * from "./CollectionOeReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports